module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("队伍风采口号")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [],
      "label": "队伍口号",
      "maxlength": "15",
      "show-word-limit": "",
      "input-align": "right",
      "autosize": "",
      "type": "textarea",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入队伍口号"
    },
    model: {
      value: (_vm.formData.kouhao),
      callback: function($$v) {
        _vm.$set(_vm.formData, "kouhao", $$v)
      },
      expression: "formData.kouhao"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "队伍风采视频",
      "value": _vm.formData.fc_pic.length + '/1'
    }
  }, [_c('template', {
    slot: "icon"
  }, [_c('van-icon', {
    staticClass: "question-icon",
    attrs: {
      "name": "question-o"
    },
    on: {
      "click": function($event) {
        return _vm.onQuestion('heying')
      }
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.fc_pic,
      "limit": 1,
      "name": 'fc_pic'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("请上传队伍风采视频的二维码图片")])], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2037e2e1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormFc.vue
// module id = 2249
// module chunks = 0